import {tva} from "@gluestack-ui/nativewind-utils/tva";

export const checkboxStyle = tva({
    base:
        "group/checkbox " +
        "flex-row " +
        "items-center " +
        "justify-start " +
        "web:cursor-pointer " +
        "data-[disabled=true]:cursor-not-allowed",
    variants: {
        size: {
            lg: "gap-2",
            md: "gap-2",
            sm: "gap-1.5"
        }
    }
});

export const checkboxIndicatorStyle = tva({
    base:
        "justify-center " +
        "items-center " +
        "border-outline-400 " +
        "bg-transparent " +
        "rounded " +
        "web:data-[focus-visible=true]:outline-none " +
        "web:data-[focus-visible=true]:ring-2 " +
        "web:data-[focus-visible=true]:ring-indicator-primary " +
        "data-[checked=true]:bg-primary-600 " +
        "data-[checked=true]:border-primary-600 " +
        "data-[hover=true]:data-[checked=false]:border-outline-500 " +
        "data-[hover=true]:bg-transparent " +
        "data-[hover=true]:data-[invalid=true]:border-error-700 " +
        "data-[hover=true]:data-[checked=true]:bg-primary-700 " +
        "data-[hover=true]:data-[checked=true]:border-primary-700 " +
        "data-[hover=true]:data-[checked=true]:data-[disabled=true]:border-primary-600 " +
        "data-[hover=true]:data-[checked=true]:data-[disabled=true]:bg-primary-600 " +
        "data-[hover=true]:data-[checked=true]:data-[disabled=true]:opacity-40 " +
        "data-[hover=true]:data-[checked=true]:data-[disabled=true]:data-[invalid=true]:border-error-600 " +
        "data-[hover=true]:data-[disabled=true]:border-outline-400 " +
        "data-[hover=true]:data-[disabled=true]:data-[invalid=true]:border-error-600 " +
        "data-[active=true]:data-[checked=true]:bg-primary-800 " +
        "data-[active=true]:data-[checked=true]:border-primary-800 " +
        "data-[invalid=true]:border-error-600 " +
        "data-[disabled=true]:opacity-40",
    parentVariants: {
        size: {
            lg: "w-6 h-6 border-[3px]",
            md: "w-5 h-5 border-2",
            sm: "w-4 h-4 border-2"
        }
    }
});

export const checkboxLabelStyle = tva({
    base:
        "text-blueGray-600 " +
        "font-medium " +
        "flex-shrink " +
        "flex-grow " +
        "data-[checked=true]:text-blueGray-600 " +
        "data-[hover=true]:text-blueGray-600 " +
        "data-[hover=true]:data-[checked=true]:text-blueGray-600 " +
        "data-[hover=true]:data-[checked=true]:data-[disabled=true]:text-blueGray-600 " +
        "data-[hover=true]:data-[disabled=true]:text-blueGray-600 " +
        "data-[active=true]:text-blueGray-600 " +
        "data-[active=true]:data-[checked=true]:text-blueGray-600 " +
        "data-[disabled=true]:opacity-40 " +
        "web:select-none",
    parentVariants: {
        size: {
            lg: "text-md",
            md: "text-sm",
            sm: "text-xs"
        }
    }
});

export const checkboxIconStyle = tva({
    base: "text-typography-50 fill-none",

    parentVariants: {
        size: {
            sm: "h-3 w-3",
            md: "h-4 w-4",
            lg: "h-5 w-5"
        }
    }
});
